import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=17e9d9a9&scoped=true&"
import script from "./CompareTable.vue?vue&type=script&lang=ts&"
export * from "./CompareTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=17e9d9a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9d9a9",
  null
  
)

export default component.exports